/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MigrationStatusEnum } from './migrationStatusEnum';


export interface MigrationProperties { 
    is_legacy_vcdr?: boolean;
    migrated_by?: string;
    migration_status?: MigrationStatusEnum;
    /**
     * Time at which migration status got updated
     */
    time?: Date;
}
export namespace MigrationProperties {
}


